import StringCell from "tables/common/StringCell";
// import SortHeaderWithSearchParams from "tables/common/SortHeaderWithSearchParams";
import CommonDateCell from "tables/common/CommonDateCell";
import SortHeaderWithSearchParams from "tables/common/SortHeaderWithSearchParams";
import TableActionField from "./cells/TableActionField";
import ReviewStatusCell from "./cells/ReviewStatusCell";
import TagsCell from "./cells/TagsCell";
import SentimentMeterCell from "./cells/SentimentMeterCell";

const cell = ({ getValue }) => <StringCell value={getValue()?.toString()} />;

const fullTextCell = ({ getValue }) => (
  <StringCell value={getValue()?.toString()} disableLineClamp />
);

export default [
  {
    header: "Brand",
    accessorFn: (row) => row.brandName || row.brand_name,
    id: "brand",
    size: 200,
    cell,
  },

  {
    header: "Brand Categories",
    accessorKey: "brandCategories",
    size: 230,
    cell: fullTextCell,
  },
  {
    header: "Insights",
    accessorKey: "insights",
    size: 540,
    cell: fullTextCell,
  },
  {
    header: <SortHeaderWithSearchParams name="insightful">Review</SortHeaderWithSearchParams>,
    accessorKey: "reviewStatus",
    size: 220,
    cell: ReviewStatusCell,
  },
  {
    header: "Tags",
    accessorKey: "tagsWithColors",
    size: 350,
    cell: ({ row, getValue, table }) => (
      <TagsCell row={row} getValue={getValue} allTags={table.options.meta?.allTags} />
    ),
  },
  {
    header: "Sentiment",
    accessorKey: "sentiment",
    size: 130,
    cell: SentimentMeterCell,
  },
  {
    header: "Keywords",
    accessorKey: "keywords",
    size: 400,
    cell: fullTextCell,
  },
  {
    header: (
      <SortHeaderWithSearchParams name="last-response">Last Response</SortHeaderWithSearchParams>
    ),
    accessorKey: "lastProspectResponseDate",
    size: 150,
    cell: CommonDateCell,
  },
  {
    header: "",
    id: `actions`,
    size: 50,
    cell: TableActionField,
  },
];
